import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const AuthRedirect = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true; // Prevents duplicate execution

    const handleAuth = async () => {
      try {
        await instance.initialize(); // Ensure MSAL is initialized
        const response = await instance.handleRedirectPromise();
        const accounts = instance.getAllAccounts();
        if (isMounted && accounts.length > 0) {
          instance.setActiveAccount(accounts[0]);
          navigate("/dashboard");
        } else if (isMounted) {
          navigate("/login");
        }
      } catch (error) {
        console.error("Authentication error:", error);
        navigate("/login");
      }
    };

    handleAuth();
    return () => {
      isMounted = false; // Cleanup
    };
  }, [instance, navigate]);
  return <div>Loading...</div>;
};

export default AuthRedirect;